import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import LaunchIcon from '@mui/icons-material/Launch';
import { useTheme } from '@mui/material/styles';

function NRLink({ tooltipTitle, text, url, color }) {
  const theme = useTheme();
  return (
    <Tooltip title={tooltipTitle || ''}>
      <Link
        onClick={event => {
          event.preventDefault();
          window.open(url, '_blank', 'noopener');
        }}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          textDecoration: 'none',
          cursor: 'pointer',
          color: color || theme.palette.blue.link
        }}
      >
        <span
          style={{
            flex: '1 1 auto',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={text || url}
        >
          {text || url}
        </span>
        {!!(text || url) && (
          <LaunchIcon
            style={{
              flex: '0 0 auto',
              width: 16,
              height: 16,
              marginLeft: 4,
              marginBottom: -3,
              marginTop: -4,
              color: theme.palette.text.secondary
            }}
            aria-hidden
          />
        )}
      </Link>
    </Tooltip>
  );
}

export default NRLink;
